// Routes //
export const Endpoint = {
    Document: 'document-service/api/v2/document',
    Folder: 'document-service/api/v2/folders',
    MasterData: '/report-service/api/v2/master-data'
}

export const Path = {
    Document: '/document',

    DocumentManagement: '/document-management',
    RecycleBin: '/recycle-bin',

    DocumentDetail: '/detail-document',
    ChildDocument: '/child-document',
    DocumentDownload: '/download',

    MassUpdateLog: '/mass-update-log'
}

// Style //
export const StyleConfig = {
    ScrollTableMinColumnNumber: 8,
    DefaultColumnWidth: '175px',
    FieldLabelCol: 5
}

// Field Mapper //
export const FieldsShouldMap = ['Upload By', 'Upload Date Time']

export const Fields = {
    TemplateName: 'template_name',
    DocumentID: 'document_id',
    Folders: 'folders',
    SubFolders: 'sub-folders',
    Status: 'status',
    Confidence: 'content.total_conf',
    DocType: 'doc_type'
}

export const MasterViewConfig = [
    { property: Fields.DocumentID, name: 'Document ID', default: true },
    { property: Fields.Folders, name: 'Folders', default: true, width: '250px' },
    { property: Fields.SubFolders, name: 'Sub-folders', default: true, width: '500px' },
    { property: 'creator_email', name: 'Upload By', default: true },
    { property: 'created_at', name: 'Upload Date Time', default: true },

    { property: 'last_updated', name: 'Delete Date Time', default: true },
    { property: 'last_updated_email', name: 'Deleted By', default: true },

    { property: Fields.Confidence, name: 'Confidence' },
    { property: 'physical_location', name: 'Physical Location' },

    { name: 'Document Name', width: '500px' },
    { name: 'Company Name', width: '500px' },
    { name: 'Company Address', width: '500px' },
    { name: 'Vendor Name', width: '500px' },
    { name: 'Vendor Name', width: '500px' },
    { name: 'Document Description', width: '500px' },
    { name: 'Total Amount Without VAT', width: '225px' },
    { name: 'Total Amount With VAT', width: '225px' }
]

// Unilever custom //
export const ZipFolders = ['Import Documents', 'Export Documents']
export const OthersWithDependentFolders = ['Customer Contracts']

export const VendorPortalFields = [
    'Note For Vendor',
    'Validation Status',
    'Receiving Status',
    'Baseline Date',
    'Due Date',
    'Reason ID',
    'Progressing Status',
    'Parking ID'
]

export const VendorPortalFieldsValues = {
    ReceivingStatus: ['Received', 'Returned'],
    ProgressingStatus: ['Checking', 'Parked', 'Paid'],
    ProgressingStatusWithEmptyParkingID: ['Checking', 'Posted', 'Parked', 'Paid']
}

export const LinkedFields = [
    'Contract Number',
    'Shipping Documents'
]
